import { useState, useEffect } from "react"

import wait from "@helpers/wait"

import sortItems from "./sortItems"


const useItemsStore = (request, table, tableProps) => {
  const [ data, setData ] = useState([])
  const [ items, setItems ] = useState([])
  const [ isLoading, setIsLoading ] = useState(false)

  const {
    isReady,
    operationParameters
  } = tableProps

  const isExternalItemsStore = !!tableProps.indexItems

  let isInProgress
  useEffect(() => {
    if (isInProgress) { return }
    isInProgress = true

    if (!isReady) { return }

    if (isLoading) { return }

    if (isExternalItemsStore) { return }

    /* NOTE: Setting is loading true to have only one request for index,
             otherwise cause of wait(25) multiple concurrent requests are
             sent. */
    setIsLoading(true)
    wait(25).then(() => indexItems(true))
  }, [ isReady, operationParameters, tableProps.items ])

  if (isExternalItemsStore) {
    const reload = async (showSpinner = false) => {
      if (showSpinner) {
        setIsLoading(true)
      }

      return tableProps.indexItems()
        .then(() => setIsLoading(false))
    }

    table.current.indexItems = reload

    return [ tableProps.items || [], isLoading, reload ]
  }

  const {
    filterItems,
    columnsConfig,
    indexOperation,
    onItemsUpdated,
    defaultSortColumn,
    defaultSortColumnDirection,
  } = tableProps

  const indexItems = (showSpinner = false) => {
    if (showSpinner) {
      setIsLoading(true)
    }

    return request(indexOperation, operationParameters)
      .then(({ data: response = [] }) => {
        const filteredItems = filterItems(response)
        const sortedItems = sortItems(columnsConfig, filteredItems, defaultSortColumn, defaultSortColumnDirection)

        setData(response)
        setItems(sortedItems)
        onItemsUpdated(sortedItems)
      })
      .then(() => setIsLoading(false))
  }

  table.current.filter = customFilterItems => {
    const filteredItems = customFilterItems(data)
    const sortedItems = sortItems(columnsConfig, filteredItems, defaultSortColumn, defaultSortColumnDirection)

    setItems(sortedItems)
    onItemsUpdated(sortedItems)
  }

  table.current.getItem = id => items.find(item => item.id === id)

  table.current.getItems = () => items

  table.current.indexItems = showSpinner => indexItems(showSpinner)

  table.current.addItem = item => {
    const updatedItems = [item, ...items]
    setItems(updatedItems)
    onItemsUpdated(updatedItems)
  }

  table.current.updateItem = (id, attributes = {}) => {
    const itemIndex = items.findIndex(item => item.id === id)
    items[itemIndex] = { ...items[itemIndex], ...attributes }

    setItems([...items])
    onItemsUpdated(items)
  }

  table.current.deleteItem = id => {
    const itemIndex = items.findIndex(item => item.id === id)
    items.splice(itemIndex, 1)

    setItems([...items])
    onItemsUpdated(items)
  }

  return [ items, isLoading, indexItems ]
}

export default useItemsStore
